import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  NgZone,
  OnDestroy,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import {
  BalanceQuery,
  Barcode,
  BarcodeQuery,
  BarcodeService,
  CardToken,
  CardTokenQuery,
  config,
  MemberCard,
  MemberCardQuery,
  MemberDetails,
  MemberQuery,
  PopulationQuery,
} from '@fgb/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Observable, Subscription } from 'rxjs';
import { map } from 'rxjs/operators';
import { Populations } from 'src/app/shared/utilities/populations';
import { TierLevels } from 'src/app/shared/utilities/tier-levels';
@Component({
  selector: 'fgb-barcode',
  templateUrl: './barcode.component.html',
  styleUrls: ['./barcode.component.scss'],
})
export class BarcodeComponent implements OnInit, OnDestroy, AfterViewInit {
  @Input() isHomePage: boolean = false;
  @Input() showQr: boolean = false;
  @Output() onShowQr: EventEmitter<boolean> = new EventEmitter(false);
  barcode$: Observable<Barcode>;
  populations = Populations;
  pointsBalance$: Observable<number | undefined>;
  combinedCard$: Observable<number | undefined>;
  member$: Observable<MemberDetails | undefined>;
  cardToken$: Observable<CardToken | undefined>;
  private subscription: Subscription;
  memberCard$: Observable<MemberCard | undefined>;
  memberDetails$: Observable<MemberDetails | undefined>;
  tierName: string | undefined;
  tierLevels = TierLevels;
  isFreePopulation: boolean = false;
  isPartnerPopulation: boolean = false;
  

  @ViewChild('nav', { static: false }) navRef!: ElementRef<HTMLDivElement>;
  atRightEnd = false;

  constructor(
    private barcodeService: BarcodeService,
    private barcodeQuery: BarcodeQuery,
    private balanceQuery: BalanceQuery,
    private memberCardQuery: MemberCardQuery,
    private memberQuery: MemberQuery,
    private memberDetailsQuery: MemberQuery,
    private modalService: NgbModal,
    private cardTokenQuery: CardTokenQuery,
    private populationQuery: PopulationQuery,
    private ngZone: NgZone
  ) {}

  ngOnInit() {
    this.tierName = this.memberQuery.getUserContext().tierName;
    this.memberCard$ = this.memberCardQuery.selectCurrentCard();
    this.memberDetails$ = this.memberQuery.selectMemberDetails();
    this.barcode$ = this.barcodeQuery.select();
    this.member$ = this.memberDetailsQuery.selectMemberDetails();
    this.combinedCard$ = this.balanceQuery.selectPurse(config.purseConfig.combined);
    this.subscription = this.barcodeService.fetchBarcode().subscribe();

    this.cardToken$ = this.cardTokenQuery.selectDefaultCard();

    this.pointsBalance$ = this.balanceQuery
      .selectPurse(config.purseConfig.virtualLoyalty)
      .pipe(map((bal) => Math.ceil(bal ?? 0)));

    this.isFreePopulation = this.populationQuery.userInPopulation([this.populations.Free]);
    this.isPartnerPopulation = this.populationQuery.userInPopulation([this.populations.Partner]);
  }

  //hide after for mobile nav
  ngAfterViewInit() {
    this.updateRightEnd();

    this.ngZone.runOutsideAngular(() => {
      const handler = () => this.ngZone.run(() => this.updateRightEnd());
      window.addEventListener('resize', handler);
    });
  }

  onNavScroll() {
    this.updateRightEnd();
  }

  private updateRightEnd() {
    const el = this.navRef?.nativeElement;
    if (!el) return;

    const { scrollLeft, clientWidth, scrollWidth, dir } = el;

    const isRtl = (dir || getComputedStyle(el).direction) === 'rtl';
    const current = isRtl ? Math.abs(scrollLeft) : scrollLeft;

    const epsilon = 1;
    this.atRightEnd = current + clientWidth >= scrollWidth - epsilon;
  }

  close() {
    this.modalService.dismissAll();
  }

  onClickShowQr() {
    this.showQr = !this.showQr;
    this, this.onShowQr.emit(this.showQr);
  }

  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }
}
